<!-- Content Wrapper Start -->
<div class="fm-content-wrapper fm-lovedone-page">
    <div class="container-fluid">

        @if (hasError()) {
            <div class="row mt-4">
                <div class="col-12">
                    <div class="fm-white-column text-center py-5">
                        <h4 class="fm-head-24 fm-head-sty2">Something went wrong</h4>
                        <p class="mb-3">We couldn't load the prompt details. Please try again.</p>
                        <button type="button" class="fm-common-btn" (click)="loadDetail()">Try Again</button>
                    </div>
                </div>
            </div>
        } @else if (detail()) {
            <div class="row">

                <!-- Header -->
                <div class="col-12">
                    <a routerLink="/app/scheduleprompt" class="fm-back-link mb-2 d-inline-flex align-items-center gap-2">
                        <i class="bi bi-arrow-left"></i> Back to Scheduled Prompts
                    </a>
                    <div class="fm-page-title mt-1">
                        <h2 class="fm-head-24 fm-title mb-2">Prompt Tracking: {{ detail()!.senderName || '—' }}</h2>
                        <p class="mb-0">{{ detail()!.promptTitle }}</p>
                    </div>
                </div>

                <!-- Prompt Configuration -->
                <div class="col-12 mt-4">
                    <div class="fm-border-column fm-card-st2">
                        <div class="fm-card-head">
                            <h3 class="fm-head-20 fm-card-title mb-0">Prompt Configuration</h3>
                        </div>
                        <div class="fm-card-body">
                            <div class="row g-4 align-items-center">
                                <div class="col-sm-6 col-lg">
                                    <p class="fm-card-label">Frequency:</p>
                                    <p class="fm-card-content fm-large">{{ detail()!.frequencyTypeName || '—' }}</p>
                                </div>
                                <div class="col-sm-6 col-lg">
                                    <p class="fm-card-label">Questions Per Prompt:</p>
                                    <p class="fm-card-content fm-large">{{ detail()!.questionPerPrompt  != null ? detail()!.questionPerPrompt  + ' Questions' : '—' }}</p>
                                </div>
                                <div class="col-sm-6 col-lg">
                                    <p class="fm-card-label">Delivery Method:</p>
                                    <p class="fm-card-content fm-large">{{ detail()!.mediaTypeName || '—' }}</p>
                                </div>
                                <div class="col-sm-6 col-lg">
                                    <p class="fm-card-label">Started On:</p>
                                    <p class="fm-card-content fm-large">{{ detail()!.promptStartDate ? formatDate(detail()!.promptStartDate) : '—' }}</p>
                                </div>
                                <div class="col-sm-6 col-lg">
                                    <p class="fm-card-label">Sent By</p>
                                    <div class="d-flex align-items-center gap-2 mt-1">
                                        @if (detail()!.senderProfilePhotoUrl) {
                                            <span class="fm-avatar">
                                                <img [src]="detail()!.senderProfilePhotoUrl" alt="{{ detail()!.senderName }}" />
                                            </span>
                                        } @else {
                                            <span class="fm-avatar fm-avatar-initials">{{ getInitials(detail()!.senderName) }}</span>
                                        }
                                        <div>
                                            <p class="fm-large fw-semibold mb-0">{{ detail()!.senderName || '—' }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Current Prompt -->
                <div class="col-12 mt-4">
                    <div class="fm-prompt-history-sec fm-border-column fm-card-st2" [ngClass]="getCurrentPromptCardClass()">
                        <div class="fm-card-head d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <h3 class="fm-head-20 fm-card-title mb-0">Current Prompt</h3>
                            @if (detail()!.currentQuestion) {
                                <span class="fm-status-badge" [ngClass]="getStatusBadgeClass(detail()!.currentQuestion!)">
                                    <i class="bi fm-badge-icon" [ngClass]="getTimelineIcon(detail()!.currentQuestion!)"></i>
                                    {{ getStatusLabel(detail()!.currentQuestion!) }}
                                </span>
                            }
                        </div>
                        <div class="fm-card-body">
                            @if (detail()!.currentQuestion) {
                                <p class="fm-label mb-1">
                                    Delivered on {{ formatDate(detail()!.currentQuestion!.deliveredDate) }}
                                    @if (detail()!.currentQuestion!.expiryDate) {
                                        &nbsp;&bull;&nbsp; Expires {{ formatDate(detail()!.currentQuestion!.expiryDate) }}
                                    }
                                </p>
                                <div class="fm-question-list mt-3">
                                    <label class="fm-question-label">Question #{{ detail()!.currentQuestion!.questionNumber }}:</label>
                                    <p class="fm-large mt-1">{{ detail()!.currentQuestion!.questionText }}</p>
                                </div>
                                @if (detail()!.currentQuestion!.hasResponded) {
                                    <div class="fm-prompt-footer mt-3">
                                        @if (detail()!.currentQuestion!.responseMediaUrl) {
                                            <a [href]="detail()!.currentQuestion!.responseMediaUrl" target="_blank" class="fm-view-story-btn">
                                                View Response <i class="bi bi-arrow-right"></i>
                                            </a>
                                        }
                                        @if (detail()!.currentQuestion!.transcription) {
                                            <div class="fm-transcription mt-3">
                                                <label class="fm-question-label">Your Response:</label>
                                                <p class="fm-large mt-1">{{ detail()!.currentQuestion!.transcription }}</p>
                                            </div>
                                        }
                                    </div>
                                } @else if (!detail()!.currentQuestion!.isExpired) {
                                    <div class="fm-prompt-footer mt-3">
                                        <a href="#" class="fm-record-response-btn">
                                            <i class="bi bi-mic-fill"></i>
                                            Record a Response
                                        </a>
                                    </div>
                                }
                            } @else {
                                <p class="mb-0 fm-large text-center py-3">No current prompt has been delivered yet.</p>
                            }
                        </div>
                    </div>
                </div>

                <!-- Previous Prompts -->
                <div class="col-12 mt-4">
                    <div class="fm-prompt-history-sec fm-border-column fm-card-st2">
                        <div class="fm-card-head d-flex justify-content-between align-items-center flex-wrap gap-3">
                            <h3 class="fm-head-20 fm-card-title mb-0">Previous Prompts</h3>
                            <ul class="fm-history-filter mb-0">
                                <li><button class="fm-history-filter-btn" type="button" [class.active]="activeFilter() === 'all'" (click)="setFilter('all')">All</button></li>
                                <li><button class="fm-history-filter-btn" type="button" [class.active]="activeFilter() === 'responded'" (click)="setFilter('responded')">Responded</button></li>
                                <li><button class="fm-history-filter-btn" type="button" [class.active]="activeFilter() === 'waiting'" (click)="setFilter('waiting')">Awaiting Response</button></li>
                                <li><button class="fm-history-filter-btn" type="button" [class.active]="activeFilter() === 'not-responded'" (click)="setFilter('not-responded')">No Response Received</button></li>
                            </ul>
                        </div>
                        <div class="fm-card-body">
                            @if (filteredHistory().length === 0) {
                                <div class="text-center py-4">
                                    @if (activeFilter() === 'all') {
                                        <p class="mb-0 fm-large">No previous prompt history yet.</p>
                                    } @else if (activeFilter() === 'responded') {
                                        <p class="mb-0 fm-large">You haven't responded to any previous prompts yet.</p>
                                    } @else if (activeFilter() === 'waiting') {
                                        <p class="mb-0 fm-large">No prompts are currently awaiting a response.</p>
                                    } @else {
                                        <p class="mb-0 fm-large">No prompts without a response were found.</p>
                                    }
                                </div>
                            } @else {
                                <div class="accordion fm-accordion" id="fmInviteeHistoryAccordion">
                                    @for (q of filteredHistory(); track q.questionId; let i = $index) {
                                        <div class="fm-history-item" [ngClass]="getHistoryItemClass(q)">
                                            <div class="fm-timeline-icon">
                                                <span class="fm-timeline-dot">
                                                    <i class="bi fm-timeline-icon-i" [ngClass]="getTimelineIcon(q)"></i>
                                                </span>
                                            </div>
                                            <div class="fm-history-box">
                                                <div class="accordion-item fm-accordion-item">
                                                    <h2 class="accordion-header fm-accordion-header">
                                                        <button class="accordion-button fm-accordion-button" type="button"
                                                            data-bs-toggle="collapse"
                                                            [attr.data-bs-target]="'#inviteeQ' + i"
                                                            aria-expanded="true"
                                                            [attr.aria-controls]="'inviteeQ' + i">
                                                            <div class="fm-history-content">
                                                                <div class="fm-history-top">
                                                                    <div>
                                                                        <h3 class="fm-head-20 fm-history-prompt-name">Question #{{ q.questionNumber }}</h3>
                                                                        <p class="fm-history-send-date">Delivered on {{ formatDate(q.deliveredDate) }}</p>
                                                                    </div>
                                                                    @if (q.hasResponded) {
                                                                        <div class="fm-status-wrap">
                                                                            <span class="fm-status-badge fm-status-success">
                                                                                <i class="bi bi-check-circle-fill fm-badge-icon"></i>
                                                                                {{ getStatusLabel(q) }}
                                                                            </span>
                                                                        </div>
                                                                    } @else {
                                                                        <span class="fm-status-badge" [ngClass]="getStatusBadgeClass(q)">
                                                                            <i class="bi fm-badge-icon" [ngClass]="getTimelineIcon(q)"></i>
                                                                            {{ getStatusLabel(q) }}
                                                                        </span>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </h2>
                                                    <div [id]="'inviteeQ' + i" class="accordion-collapse collapse show">
                                                        <div class="accordion-body fm-accordion-body">
                                                            <div class="fm-question-list">
                                                                <label class="fm-question-label">Question:</label>
                                                                <p class="fm-large mt-1">{{ q.questionText }}</p>
                                                            </div>
                                                            @if (q.hasResponded) {
                                                                @if (q.transcription) {
                                                                    <div class="fm-transcription mt-3">
                                                                        <label class="fm-question-label">Your Response:</label>
                                                                        <p class="fm-large mt-1">{{ q.transcription }}</p>
                                                                    </div>
                                                                }
                                                                @if (q.responseMediaUrl) {
                                                                    <div class="fm-prompt-footer mt-2">
                                                                        <a [href]="q.responseMediaUrl" target="_blank" class="fm-view-story-btn">
                                                                            View Response <i class="bi bi-arrow-right"></i>
                                                                        </a>
                                                                    </div>
                                                                }
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>

            </div>
        } @else {
            <div class="row mt-4">
                <div class="col-12">
                    <div class="fm-white-column text-center py-5">
                        <h4 class="fm-head-24 fm-head-sty2">No data available</h4>
                        <p class="mb-3">We couldn't find details for this prompt. It may have been removed or you may not have access.</p>
                        <a routerLink="/app/scheduleprompt" class="fm-common-btn">Back to Scheduled Prompts</a>
                    </div>
                </div>
            </div>
        }

    </div>
</div>
<!-- Content Wrapper End -->